(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stw-klaviyo-scratch"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const config = document.getElementById('stw-klaviyo-config');
  if (!config || config.dataset.ready) return;
  config.dataset.ready = '1';
  const formId = 'WJGge2';
  const prefix = 'stw_scratch_10_v1:';
  const memory = {};
  const read = (area, key) => { try { return window[area].getItem(prefix + key); } catch { return memory[area + key] || null; } };
  const write = (area, key, value) => { memory[area + key] = String(value); try { window[area].setItem(prefix + key, String(value)); } catch {} };
  const excluded = () => /(?:bett|alpina|(?:^|[\/-])beds?(?:[\/-]|$))/i.test(location.pathname) || /^\/it(?:\/|$)/i.test(location.pathname) || /(?:^|\/)(?:cart|checkout|checkouts|kasse)(?:\/|$)/i.test(location.pathname);
  const suppressed = () => config.dataset.subscriber === 'true' || read('localStorage', 'subscribed') === '1' || read('localStorage', 'dismissed') === '1' || Number(read('localStorage', 'dismissedUntil')) > 0;
  const preview = new URLSearchParams(location.search).get('stw_scratch_preview') === '1';
  let opened = false;
  let redirected = false;
  function enhance() {
    document.querySelectorAll('[data-stw-scratch="v2"]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) { card.dataset.revealed = 'true'; return; }
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;touch-action:none;cursor:crosshair';
      const content = card.firstElementChild;
      const accessible = document.createElement('button');
      accessible.type = 'button';
      accessible.textContent = 'Rabatt ohne Rubbeln aufdecken';
      const hiddenStyle = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap;border:0';
      accessible.style.cssText = hiddenStyle;
      accessible.addEventListener('focus', () => { accessible.style.cssText = 'display:block;margin:8px auto;border:1px solid #222;background:white;color:#222;font:12px STWJost,sans-serif;padding:8px;cursor:pointer'; });
      accessible.addEventListener('blur', () => { accessible.style.cssText = hiddenStyle; });
      let revealed = false, drawing = false, last = null, lastCheck = 0;
      const reveal = () => {
        if (revealed) return;
        revealed = true;
        card.dataset.revealed = 'true';
        canvas.remove();
        content?.removeAttribute('aria-hidden');
        accessible.remove();
        observer.disconnect();
      };
      const draw = () => {
        if (revealed) return;
        const rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        const gradient = ctx.createLinearGradient(0, 0, rect.width, rect.height);
        gradient.addColorStop(0, '#d5a03d'); gradient.addColorStop(.5, '#e5c76c'); gradient.addColorStop(1, '#a58d35');
        ctx.fillStyle = gradient; ctx.fillRect(0, 0, rect.width, rect.height);
        let seed = 731;
        for (let y = 0; y < rect.height; y += 2) for (let x = 0; x < rect.width; x += 2) {
          seed = (seed * 1664525 + 1013904223) >>> 0;
          ctx.fillStyle = (seed & 1) ? '#fff' : '#59420b'; ctx.globalAlpha = ((seed >>> 8) % 15) / 100;
          ctx.fillRect(x, y, 2, 2);
        }
        ctx.globalAlpha = 1; ctx.fillStyle = '#fff9'; ctx.textAlign = 'center'; ctx.font = '600 ' + Math.min(28, rect.width / 10) + 'px STWJost, sans-serif';
        ctx.fillText('HIER RUBBELN', rect.width / 2, rect.height / 2 + 10);
      };
      const check = () => {
        if (revealed || !canvas.width || !canvas.height) return;
        const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        let clear = 0, total = 0;
        for (let i = 3; i < pixels.length; i += 64) { total++; if (pixels[i] < 80) clear++; }
        if (clear / total > .38) reveal();
      };
      const erase = e => {
        const rect = canvas.getBoundingClientRect(), p = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        ctx.globalCompositeOperation = 'destination-out'; ctx.lineWidth = 44; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(last?.x ?? p.x, last?.y ?? p.y); ctx.lineTo(p.x, p.y); ctx.stroke();
        ctx.beginPath(); ctx.arc(p.x, p.y, 22, 0, Math.PI * 2); ctx.fill(); last = p;
      };
      canvas.addEventListener('pointerdown', e => { if (e.button !== 0 || revealed) return; drawing = true; last = null; canvas.setPointerCapture(e.pointerId); erase(e); });
      canvas.addEventListener('pointermove', e => { if (!drawing || revealed) return; erase(e); if (performance.now() - lastCheck > 120) { lastCheck = performance.now(); check(); } });
      const end = () => { drawing = false; last = null; check(); };
      canvas.addEventListener('pointerup', end); canvas.addEventListener('pointercancel', end); canvas.addEventListener('lostpointercapture', end);
      accessible.addEventListener('click', reveal);
      card.appendChild(canvas); card.after(accessible); content?.setAttribute('aria-hidden', 'true');
      const observer = new ResizeObserver(draw); observer.observe(card); draw();
      // The CSS reveals the native CTA only after scratch or accessible reveal.
    });
  }
  const mutationObserver = new MutationObserver(enhance);
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.formId !== formId) return;
    const type = event.detail.type;
    if (type === 'open') {
      opened = true;
      if (!preview) write('sessionStorage', 'shown', '1');
      mutationObserver.observe(document.body, { childList: true, subtree: true });
      enhance();
    }
    if (type === 'submit' && (event.detail.metaData?.$email || event.detail.metaData?.email)) {
      write('localStorage', 'subscribed', '1');
      if (!redirected) {
        redirected = true;
        setTimeout(() => location.assign('https://wa.me/393757790196?text=Rabatt%20freischalten'), 200);
      }
    }
    if (type === 'close') {
      mutationObserver.disconnect();
      if (!preview && read('localStorage', 'subscribed') !== '1') write('localStorage', 'dismissed', '1');
    }
  });
  if (config.dataset.editor === 'true' || excluded()) return;
  if (!preview && (suppressed() || read('sessionStorage', 'shown') === '1')) return;
  const started = Number(read('sessionStorage', 'started')) || Date.now();
  if (!preview) write('sessionStorage', 'started', started);
  setTimeout(() => {
    if (opened || excluded() || (!preview && suppressed())) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }, preview ? 500 : Math.max(0, 8000 - (Date.now() - started)));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stw-scratch-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const config = document.getElementById('stw-klaviyo-config');
  if (!config || config.dataset.ready) return;
  config.dataset.ready = '1';
  const formId = 'WJGge2';
  const prefix = 'stw_scratch_10_v1:';
  const memory = {};
  const read = (area, key) => { try { return window[area].getItem(prefix + key); } catch { return memory[area + key] || null; } };
  const write = (area, key, value) => { memory[area + key] = String(value); try { window[area].setItem(prefix + key, String(value)); } catch {} };
  const excluded = () => /(?:bett|alpina|(?:^|[\/-])beds?(?:[\/-]|$))/i.test(location.pathname) || /^\/it(?:\/|$)/i.test(location.pathname) || /(?:^|\/)(?:cart|checkout|checkouts|kasse)(?:\/|$)/i.test(location.pathname);
  const suppressed = () => config.dataset.subscriber === 'true' || read('localStorage', 'subscribed') === '1' || read('localStorage', 'dismissed') === '1' || Number(read('localStorage', 'dismissedUntil')) > 0;
  const preview = new URLSearchParams(location.search).get('stw_scratch_preview') === '1';
  let opened = false;
  let redirected = false;
  function enhance() {
    document.querySelectorAll('[data-stw-scratch="v2"]').forEach(card => {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) { card.dataset.revealed = 'true'; return; }
      canvas.setAttribute('aria-hidden', 'true');
      canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;touch-action:none;cursor:crosshair';
      const content = card.firstElementChild;
      const accessible = document.createElement('button');
      accessible.type = 'button';
      accessible.textContent = 'Rabatt ohne Rubbeln aufdecken';
      const hiddenStyle = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap;border:0';
      accessible.style.cssText = hiddenStyle;
      accessible.addEventListener('focus', () => { accessible.style.cssText = 'display:block;margin:8px auto;border:1px solid #222;background:white;color:#222;font:12px STWJost,sans-serif;padding:8px;cursor:pointer'; });
      accessible.addEventListener('blur', () => { accessible.style.cssText = hiddenStyle; });
      let revealed = false, drawing = false, last = null, lastCheck = 0;
      const reveal = () => {
        if (revealed) return;
        revealed = true;
        card.dataset.revealed = 'true';
        canvas.remove();
        content?.removeAttribute('aria-hidden');
        accessible.remove();
        observer.disconnect();
      };
      const draw = () => {
        if (revealed) return;
        const rect = card.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(rect.width * dpr);
        canvas.height = Math.round(rect.height * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        const gradient = ctx.createLinearGradient(0, 0, rect.width, rect.height);
        gradient.addColorStop(0, '#d5a03d'); gradient.addColorStop(.5, '#e5c76c'); gradient.addColorStop(1, '#a58d35');
        ctx.fillStyle = gradient; ctx.fillRect(0, 0, rect.width, rect.height);
        let seed = 731;
        for (let y = 0; y < rect.height; y += 2) for (let x = 0; x < rect.width; x += 2) {
          seed = (seed * 1664525 + 1013904223) >>> 0;
          ctx.fillStyle = (seed & 1) ? '#fff' : '#59420b'; ctx.globalAlpha = ((seed >>> 8) % 15) / 100;
          ctx.fillRect(x, y, 2, 2);
        }
        ctx.globalAlpha = 1; ctx.fillStyle = '#fff9'; ctx.textAlign = 'center'; ctx.font = '600 ' + Math.min(28, rect.width / 10) + 'px STWJost, sans-serif';
        ctx.fillText('HIER RUBBELN', rect.width / 2, rect.height / 2 + 10);
      };
      const check = () => {
        if (revealed || !canvas.width || !canvas.height) return;
        const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        let clear = 0, total = 0;
        for (let i = 3; i < pixels.length; i += 64) { total++; if (pixels[i] < 80) clear++; }
        if (clear / total > .38) reveal();
      };
      const erase = e => {
        const rect = canvas.getBoundingClientRect(), p = { x: e.clientX - rect.left, y: e.clientY - rect.top };
        ctx.globalCompositeOperation = 'destination-out'; ctx.lineWidth = 44; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(last?.x ?? p.x, last?.y ?? p.y); ctx.lineTo(p.x, p.y); ctx.stroke();
        ctx.beginPath(); ctx.arc(p.x, p.y, 22, 0, Math.PI * 2); ctx.fill(); last = p;
      };
      canvas.addEventListener('pointerdown', e => { if (e.button !== 0 || revealed) return; drawing = true; last = null; canvas.setPointerCapture(e.pointerId); erase(e); });
      canvas.addEventListener('pointermove', e => { if (!drawing || revealed) return; erase(e); if (performance.now() - lastCheck > 120) { lastCheck = performance.now(); check(); } });
      const end = () => { drawing = false; last = null; check(); };
      canvas.addEventListener('pointerup', end); canvas.addEventListener('pointercancel', end); canvas.addEventListener('lostpointercapture', end);
      accessible.addEventListener('click', reveal);
      card.appendChild(canvas); card.after(accessible); content?.setAttribute('aria-hidden', 'true');
      const observer = new ResizeObserver(draw); observer.observe(card); draw();
      // The CSS reveals the native CTA only after scratch or accessible reveal.
    });
  }
  const mutationObserver = new MutationObserver(enhance);
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.formId !== formId) return;
    const type = event.detail.type;
    if (type === 'open') {
      opened = true;
      if (!preview) write('sessionStorage', 'shown', '1');
      mutationObserver.observe(document.body, { childList: true, subtree: true });
      enhance();
    }
    if (type === 'submit' && (event.detail.metaData?.$email || event.detail.metaData?.email)) {
      write('localStorage', 'subscribed', '1');
      if (!redirected) {
        redirected = true;
        setTimeout(() => location.assign('https://wa.me/393757790196?text=Rabatt%20freischalten'), 200);
      }
    }
    if (type === 'close') {
      mutationObserver.disconnect();
      if (!preview && read('localStorage', 'subscribed') !== '1') write('localStorage', 'dismissed', '1');
    }
  });
  if (config.dataset.editor === 'true' || excluded()) return;
  if (!preview && (suppressed() || read('sessionStorage', 'shown') === '1')) return;
  const started = Number(read('sessionStorage', 'started')) || Date.now();
  if (!preview) write('sessionStorage', 'started', started);
  setTimeout(() => {
    if (opened || excluded() || (!preview && suppressed())) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }, preview ? 500 : Math.max(0, 8000 - (Date.now() - started)));
})();
  } catch(e) { console.error(e); }
})();

})();
